import React, { useEffect, useState } from "react";
import "./index.less";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import { ProgressBusiness } from "@business/newCreateRequest/common/progress";
import { stepReviewBusiness } from "@business/newCreateRequest/stepsItems/review";
import { Button, Dialog } from "oned";
import { combine } from "fe-toolkit";
import { withRouter } from "react-router-dom";
import { AmplitudeEventName } from "@common/enums/base";
import { getCurrentEnv, sendAmplitude_Default } from "@common/utils";
import "./index.less";
import Cookies from "js-cookie";
var disclaimerText = "Please note that pursuant to your Lease Agreement, you may be charged for any repairs or replacements required at the property due to damages caused by leaseholders, occupants, guests, or pets.";
var Disclaimer = inject(combine(ProgressBusiness, stepReviewBusiness))(observer(function (props) {
    var setDisclaimerData = props.setDisclaimerData, history = props.history, currentUser = props.currentUser, targetDisclaimer = props.targetDisclaimer;
    var _a = useState(false), visible = _a[0], setVisible = _a[1];
    useEffect(function () {
        if (!targetDisclaimer) {
            sendAmplitude_Default(AmplitudeEventName.WOCreation_Disclaimer_RSP, {
                userId: currentUser.userId,
                residentId: currentUser.residentId,
                clientId: Cookies.get('clientId'),
                env: getCurrentEnv(),
            });
        }
    }, []);
    var onContinue = function () {
        setDisclaimerData(false);
        sendAmplitude_Default(AmplitudeEventName.WOCreation_Disclaimer_proceed_RSP, {
            userId: currentUser.userId,
            residentId: currentUser.residentId,
            clientId: Cookies.get('clientId'),
            env: getCurrentEnv(),
        });
    };
    var onCancel = function () {
        setVisible(true);
        sendAmplitude_Default(AmplitudeEventName.WOCreation_Disclaimer_cancel_RSP, {
            userId: currentUser.userId,
            residentId: currentUser.residentId,
            clientId: Cookies.get('clientId'),
            env: getCurrentEnv(),
        });
    };
    var onDiscard = function () {
        history.push("/");
    };
    var onContinueEdit = function () {
        setVisible(false);
    };
    return React.createElement(React.Fragment, null,
        React.createElement(Dialog, { visible: visible, title: "Are you sure?", closable: true, destroyOnClose: false, onClose: function () { return setVisible(false); }, animation: "zoom", maskClosable: true, maskAnimation: "fade", hasFooter: false, className: "hack-dialog" },
            React.createElement("div", { className: "text-middle" },
                "Discarding acknowledgement will redirect you to the homepage. ",
                React.createElement("br", null),
                "Do you wish to continue?"),
            React.createElement("div", { className: "pt-5 pb-4 d-flex justify-content-end" },
                React.createElement(Button, { type: "secondary", onClick: onDiscard },
                    React.createElement("span", { className: 'f14' }, "Yes, discard")),
                React.createElement("div", { className: "mr-3" }),
                React.createElement(Button, { onClick: onContinueEdit },
                    React.createElement("span", { className: 'f14' }, "Continue editing")))),
        React.createElement("div", { className: "dsm-card rsp-step-details" },
            React.createElement("div", { className: "dsm-card-body cardBox" },
                React.createElement("div", { className: "mt-4" },
                    React.createElement("div", { className: "titleBox" },
                        React.createElement("span", { className: "title" }, "Disclaimer")),
                    React.createElement("div", { className: "mt-4 pb-4" }, disclaimerText)))),
        React.createElement(Button, { type: "primary", className: "w-100 mt-4 dsm-btn-secondary dsm-btn", onClick: function () { return onCancel(); } }, "Cancel"),
        React.createElement(Button, { type: "primary", className: "w-100 my-3 dsm-btn-primary dsm-btn", onClick: function () { return onContinue(); } }, "Continue"));
}));
export default withRouter(Disclaimer);
